// DO NOT UPDATE MANUALLY: Generated from script during build time
export const VERSION = '13.3.0-beta.20260512.1138';
